import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../../util/Rest';
import {
  DELINQUENCY_LOGIC_BLOCK,
  ORG_CREDITOR_LOGIC_BLOCK,
  NEVER_SELECT_LOGIC,
  ON_HOLD_LOGIC,
  SKP_LOCATOR_SERV_TYPE,
} from '../../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialData = {
  creditReportingData: {},
  creditReportingStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'creditReporting',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCreditReportingData: (state, action) => {
      state.creditReportingData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCreditReportingData: (state, action) => {
      state.creditReportingStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetStatus: (state) => {
      state.creditReportingStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchDropDownData,
  fetchError,
  fetchCreditReportingData,
  postCreditReportingData,
  resetMsg,
  resetStatus,
} = slice.actions;
export const fetchCreditReporting = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [
          DELINQUENCY_LOGIC_BLOCK,
          ORG_CREDITOR_LOGIC_BLOCK,
          NEVER_SELECT_LOGIC,
          ON_HOLD_LOGIC,
          SKP_LOCATOR_SERV_TYPE,
        ],
      }),
      httpGet(`${CLIENT_MAINTENANCE}/get/clientcreditreporting/${clientNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const creditReportingData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (creditReportingData?.status && creditReportingData.status === 200) {
          dispatch(fetchCreditReportingData(creditReportingData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postCreditReporting = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/clientcreditreportbing`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCreditReportingData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetCreditReportingStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
